import { PartnerApi } from "@/zh-website/src/views/partner/api";
import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";

export class PartnerService extends BaseAbstractService {
  static getCooperationCaseList(query) {
    return PartnerApi.getCooperationCaseList(this.request, query);
  }
  static getCooperationCaseDetail(query) {
    return PartnerApi.getCooperationCaseDetail(this.request, query);
  }
  static addCooperationExpertApply(query) {
    return PartnerApi.addCooperationExpertApply(this.request, query);
  }
  static addCooperationExpertRecommend(query) {
    return PartnerApi.addCooperationExpertRecommend(this.request, query);
  }
  static addCooperationCourse(query) {
    return PartnerApi.addCooperationCourse(this.request, query);
  }
  static addSupplier(query) {
    return PartnerApi.addSupplier(this.request, query);
  }
  static addBidding(query) {
    return PartnerApi.addBidding(this.request, query);
  }
  static getBiddingProject(query) {
    return PartnerApi.getBiddingProject(this.request, query);
  }
  static downloadBidding(query) {
    return PartnerApi.downloadBidding(this.request, query);
  }
  static addReport(query) {
    return PartnerApi.addReport(this.request, query);
  }
}
PartnerService.setRequest(RequestService);
